import { collection, getDocs, addDoc, getFirestore } from 'firebase/firestore';
// import { db } from '../../config/firebase';
import { COLLECTIONS } from './collections';

export const categoriesService = {
  async getAll(): Promise<string[]> {
    const db = getFirestore();
    const querySnapshot = await getDocs(collection(db, COLLECTIONS.CATEGORIES));
    return querySnapshot.docs.map(doc => doc.data().name as string);
  },
  
  async add(category: string): Promise<string> {
    const db = getFirestore();
    const docRef = await addDoc(collection(db, COLLECTIONS.CATEGORIES), {
      name: category.toLowerCase()
    });
    return docRef.id;
  }
};
